import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "错误",
  "use": "错误-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"错误\"><defs><style>#错误 .cls-1{fill:#f44f4f;}</style></defs><g id=\"错误_页面-1\"><g id=\"错误_数据保护-任务详情_立即_预定_展开\" data-name=\"数据保护-任务详情（立即/预定）展开\"><g id=\"错误_错误\"><path id=\"错误_形状\" class=\"cls-1\" d=\"M24,0A24,24,0,1,0,41,7,24,24,0,0,0,24,0Zm2.74,10.26L26,27.89H22l-.78-17.63ZM24,37.74a3.43,3.43,0,1,1,2.42-1,3.43,3.43,0,0,1-2.42,1Z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol